import React from 'react'
import useTranslation from 'next-translate/useTranslation'

import { useBuilderFormContext } from 'components/business/CampaignBuilder'
import { RadioGroup } from 'components/ui'
import { TextAlign } from 'types/domain'

import StyleItem from '../../StyleItem'

const textAlignPath = 'formSetting.textStyle.align'

const TextAlignSetting = () => {
  const { t } = useTranslation('componentCampaignBuilder')
  const form = useBuilderFormContext()

  const options = [TextAlign.Start, TextAlign.Center, TextAlign.End].map((value) => ({
    label: t(`styles.textStyle.align.${value}`),
    value,
  }))

  const { value, onChange } = form.getInputProps(textAlignPath)

  return (
    <StyleItem label={t('styles.textStyle.title')}>
      <RadioGroup data={options} value={value ?? TextAlign.Start} onChange={onChange} />
    </StyleItem>
  )
}

export default TextAlignSetting
